import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment";
import { connect } from "react-redux";

//componentes
import "./montosXTerapias.css";
import Alert from "../../modal/alert";
import { fetchSedes } from "../../utils/sedesApi";

class MontosAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cedula: "",
      cedula2: "",
      nombre: "",
      especialista: "",
      horario: "",
      ifechaespera1: [],
      ifechaespera2: [],
      fechaespera: moment().format("YYYY-MM-DD"),
      clientetrue: false,
      fechaNacimiento: "",
      //valorini:'1',
      modificarOn: false,
      iddonante: "",
      reemplazarOn: false,
      iterapeuta: [],
      imedicos: [],
      terapeutaV: "",
      terapeutaN: "",
      sede: "",
      casos: "",
      inventario: "",
      iinventario: [],
      icasos: [],
      monto: "",
      monto22: "",
      especialista2: "",
      sedes: [],
    };
    moment.locale("es");
  }

  limpiar = () => {
    this.setState({
      cedula: "",
      cedula2: "",
      nombre: "",
      especialista: "",
      especialista2: "",
      horario: "",
      //valorini:'1',
      ifechaespera1: [],
      ifechaespera2: [],
      fechaespera: moment().format("YYYY-MM-DD"),
      fechaNacimiento: "",
      modificarOn: false,
      iddonante: "",
      reemplazarOn: false,
      terapeutaV: "",
      terapeutaN: "",
      sede: "",
      casos: "",
      imedicos: [],
      inventario: "",
      iinventario: [],
      monto: "",
      monto22: "",
    });
    this.buscarMedicos();
  };

  onChange(e) {
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
    });
    
    if (e.target.name === "sede") {
      this.setState({
        imedicos: [],
        casos: "",
      });
    }
    if (e.target.name === "casos") {
      this.terapeutasDisponibles(e.target.value);
      this.buscarInventario(e.target.value);
    }
  }

  cerrarlistadocli() {
    this.setState({
      ifechaevo: [],
      clientetrue: false,
    });
  }

  consultar2(e, f) {
    let data = new FormData();
    data.append("cedula", e);
    data.append("boton", "Consultar");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/medicos.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        if (res.data) {
          this.setState({
            cedula: res.data.variable1,
            cedula2: res.data.variable1,
            nombre: res.data.variable2,
            especialista: res.data.variable3,
            fechaNacimiento: res.data.variable4,
            sede: res.data.variable5,
            clientetrue: false,
            modificarOn: true,
            iddonante: f,
          });
          //this.buscarcitaspacientes();
        } else {
          this.setState({
            mensajealerta: true,
            tituloM: "Montos Por Especialidad.",
            cuerpoM:
              "No se encontro la cedula que se desea consultar, verifique Gracias...",
          });
        }
      });
  }

  guardar = () => {
    if (
      this.state.casos.length > 0 &&
      this.state.especialista.length > 0 &&
      this.state.inventario.length > 0 &&
      this.state.monto.length > 0
    ) {
      let data = new FormData();
      data.append("especialidad", this.state.casos);
      data.append("especialista", this.state.especialista);
      data.append("codigoItem", this.state.inventario);
      data.append("monto", this.state.monto);
      data.append("especialista2", this.state.especialista2);
      data.append("monto2", this.state.monto22);
      data.append("boton", "Grabar");
      let config = {
        headers: { "Content-Type": "text/html" },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/asociarPagosTerapia.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.setState({
              mensajealerta: true,
              tituloM: "Montos Por Especialidad.",
              cuerpoM: "Se Agrego la Asosiación",
              especialista2: "",
              monto22: "",
            });
            this.buscarMedicos();
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Montos Por Especialidad.",
              cuerpoM: "El Item ya Esta Creado,  verifique Gracias...",
            });
          }
        });
    }
  };

  eliminar = (e) => {
    let data = new FormData();
    data.append("idasociar", e);
    data.append("boton", "Eliminar");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/asociarPagosTerapia.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        if (res.data.variable1) {
          this.setState({
            mensajealerta: true,
            tituloM: "Montos Por Especialidad.",
            cuerpoM: "Se Elimino el Item Asociado",
          });
          this.buscarMedicos();
        } else {
          this.setState({
            mensajealerta: true,
            tituloM: "Montos Por Especialidad.",
            cuerpoM: "Ocurrio un Error,  verifique Gracias...",
          });
        }
      });
  };

  buscarMedicos = () => {
    let data = new FormData();
    data.append("boton", "Buscar");
    let config = {
      headers: { "Content-Type": "text/html" },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/asociarPagosTerapia.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        if (res.data.variable1) {
          let xifechaespera1 = res.data.variable2;
          this.setState({
            ifechaespera1: [],
            ifechaespera1: xifechaespera1,
          });
        } else {
          this.setState({
            ifechaespera1: [],
          });
        }
      });
  };

  getButtons = () => {
    let botones = [];
    let bandera = 0;
    //console.log(this.state.cantpagi+"-"+this.state.paginactiva)
    botones.push(
      <button
        className={
          parseInt(this.state.paginactiva) > 10
            ? "botonspanOf"
            : "botonspanocultar"
        }
        name="izquierdaS"
        onClick={this.busquedapagi}
      >
        &lt;
      </button>
    );

    for (let i = 0; i < this.state.cantpagi; i++) {
      bandera = 0;
      if (
        i + 1 >= parseInt(this.state.desde) &&
        i + 1 <= parseInt(this.state.hasta)
      ) {
        bandera = 1;
      }
      botones.push(
        <button
          className={
            parseInt(this.state.paginactiva) === i + 1
              ? "botonspanOf"
              : "botonspan"
          }
          name={parseInt(i) + 1}
          onClick={this.busquedapagi}
          id={bandera === 0 ? "ocultar" : ""}
        >
          {parseInt(i) + 1}
        </button>
      );
    }

    botones.push(
      <button
        className={
          parseInt(this.state.cantpagi) > 10
            ? "botonspanOf"
            : "botonspanocultar"
        }
        name="derechaS"
        onClick={this.busquedapagi}
      >
        &gt;
      </button>
    );
    botones.push(
      <button
        className={
          parseInt(this.state.cantpagi) > 10
            ? "botonspanOf"
            : "botonspanocultar"
        }
        name="derechaD"
        onClick={this.busquedapagi}
      >
        &gt;&gt;
      </button>
    );

    return botones;
  };

  busquedapagi = (e) => {
    let spaso = 0;
    let numepag = 0;
    let desde1 = 0;
    let hasta1 = 0;
    let resulpaghasta = 0;
    let resulpagdesde = 0;
    let difehasta = 0;
    let paso = 0;

    if (e.target.name === "izquierdaS") {
      spaso = 1;
      numepag = parseInt(this.state.paginactiva) - 1;
      if (numepag === 0) numepag = 1;
    }
    if (e.target.name === "derechaS") {
      spaso = 1;
      numepag = parseInt(this.state.paginactiva) + 1;
      if (numepag > parseInt(this.state.cantpagi))
        numepag = parseInt(this.state.cantpagi);
    }
    if (e.target.name === "derechaD") {
      spaso = 1;
      numepag = parseInt(this.state.cantpagi);
    }

    if (parseInt(spaso) === 0) {
      numepag = parseInt(e.target.name);
    }

    resulpaghasta = parseInt(this.state.cantpagi) - numepag;

    if (resulpaghasta >= 4) {
      hasta1 = numepag + 4;
      difehasta = 0;
    }
    if (resulpaghasta < 4 && resulpaghasta > 0) {
      hasta1 = numepag + resulpaghasta;
      difehasta = 4 - resulpaghasta;
    }
    if (resulpaghasta <= 0) {
      hasta1 = numepag;
      difehasta = 4;
    }
    resulpagdesde = numepag - 1;

    if (resulpagdesde <= 0) desde1 = 1;

    if (resulpagdesde < 5 && resulpagdesde > 0) {
      if (difehasta > 0) {
        if (resulpagdesde <= difehasta) {
          desde1 = numepag - resulpagdesde;
          resulpagdesde = 0;
        }
        if (resulpagdesde > difehasta) {
          desde1 = numepag - difehasta;
          resulpagdesde = resulpagdesde - difehasta;
        }
      }
      if (difehasta <= 0) desde1 = numepag;
    }
    if (resulpagdesde < 5 && resulpagdesde > 0) desde1 = desde1 - resulpagdesde;

    if (resulpagdesde >= 5) {
      if (difehasta > 0) {
        desde1 = numepag - difehasta;
        resulpagdesde = resulpagdesde - difehasta;
        paso = 1;
      }
      if (difehasta <= 0) desde1 = numepag - 5;

      if (resulpagdesde >= 5 && paso === 1) desde1 = desde1 - 5;
      if (resulpagdesde >= 1 && resulpagdesde < 5 && paso === 1)
        desde1 = desde1 - resulpagdesde;
    }

    if (resulpagdesde < 5) hasta1 = hasta1 + (5 - resulpagdesde);

    axios
      .post(
        "https://institutobilinguelasnaciones.com/terapias/backend/medicos.php/?cedula=" +
          this.state.nombre +
          "%&valorini=" +
          numepag +
          "&boton=Consultarnombre"
      )
      //if (numepag===2) console.log('https://institutobilinguelasnaciones.com/terapias/backend/medicos.php/?cedula=' + this.state.nombre + '%&valorini='+ numepag +'&boton=Consultarnombre')
      .then((res) => {
        if (res.data) {
          let xfechaevo = res.data;
          this.setState({
            ifechaevo: xfechaevo,
            clientetrue: true,
            paginactiva: numepag,
            desde: desde1,
            hasta: hasta1,
          });
        }
      });
  };

  modificar = () => {
    if (this.state.iddonante.length > 0) {
      let data = new FormData();
      data.append("idmaestroE", this.state.iddonante);
      data.append("cedula", this.state.cedula);
      data.append("especialista", this.state.especialista);
      data.append("nombre", this.state.nombre);
      data.append("fechaNacimiento", this.state.fechaNacimiento);
      data.append("sede", this.state.sede);
      data.append("boton", "modificar");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/medicos.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.limpiar();
            this.buscarMedicos();
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Maestro de Donantes.",
              cuerpoM: res.data.variable2,
            });
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Maestro de Donantes.",
              cuerpoM: res.data.variable2,
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Maestro de Donantes.",
        cuerpoM: "Ocurrio un Error, verifique por Favor.",
      });
    }
  };

  reemplazar = () => {
    if (this.state.reemplazarOn) {
      this.setState({ reemplazarOn: false });
    } else {
      this.setState({ reemplazarOn: true });
    }
  };

  buscarE = () => {
    let data = new FormData();
    data.append("boton", "Buscar");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/medicos.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        //console.log(res.data.variable3);
        //console.log(res.data.variable2);

        let xterapeuta = res.data;
        this.setState({
          iterapeuta: xterapeuta,
        });
      });
  };

  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  asociarEvaluacion = () => {
    let data = new FormData();
    data.append("boton", "Consultar");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/maestroCasosPHP.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let xcasos = res.data;
        this.setState({
          icasos: xcasos,
        });
      });
  };

  buscarInventario = (e) => {
    let data = new FormData();
    data.append("especialidad", e);
    data.append("boton", "consultaInventarioFacturar");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/inventario.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let ximedicos = res.data.variable2;
        if (res.data.variable1) {
          this.setState({
            inventario: "",
            iinventario: [],
            iinventario: ximedicos,
          });
        } else {
          this.setState({
            inventario: "",
            iinventario: [],
          });
        }
      });
  };

  terapeutasDisponibles = (e) => {
    let data = new FormData();
    data.append("idespecialidad", e);
    data.append("nivel", this.props.usuario1.nivel);
    if (this.state.sede.length === 0)
      data.append("sede", this.props.usuario1.sede);
    if (this.state.sede.length > 0) data.append("sede", this.state.sede);
    data.append("boton", "consultaTerapeutasEspecialista");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/consultaInformesTerapia.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let ximedicos = res.data.variable2;
        if (res.data.variable1) {
          this.setState({
            especialista: "",
            imedicos: [],
            imedicos: ximedicos,
          });
        } else {
          this.setState({
            especialista: "",
            imedicos: [],
          });
        }
      });
  };

  componentDidMount() {
    this.asociarEvaluacion();
    this.buscarMedicos();
    this.buscarE();
    fetchSedes().then((sedes) => this.setState({ sedes }));
  }

  render() {
    return (
      <div className="cont-principal-espera row">
        <div className="cont-espera col-12">
          {this.state.mensajealerta === true && (
            <Alert
              tituloMensaje={this.state.tituloM}
              cuerpoMensaje={this.state.cuerpoM}
              open={this.state.mensajealerta}
              handleClose={this.handleClose}
            />
          )}

          <div className="cont-titulo-espera row">
            <div className="col-12">
              <span className="tituloespera">Montos A Cobrar Por Items.</span>
            </div>
            <div className="cont-datos-espera col-12">
              <div className="row">
                <div className="xsede col-1">
                  <select
                    id="sede"
                    name="sede"
                    value={this.state.sede}
                    onChange={this.onChange.bind(this)}
                  >
                    <option>-Sucursal-</option>
                    {this.state.sedes.map((item) => (
                      <option key={item.variable1} value={String(item.variable1)}>
                        {item.variable2}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="xepecialidad col-2">
                  <select
                    id="casos"
                    name="casos"
                    value={this.state.casos}
                    onChange={this.onChange.bind(this)}
                  >
                    <option>-Seleccione Especialidad-</option>
                    {this.state.icasos.map((item, i) => {
                      return (
                        <option key={i} value={item.variable1}>
                          {item.variable2}
                        </option>
                      );
                    })}
                  </select>
                </div>

                <div className="xespecialista col-2">
                  <select
                    id="especialista"
                    name="especialista"
                    value={this.state.especialista}
                    onChange={this.onChange.bind(this)}
                  >
                    <option>-Seleccione Especialista-</option>
                    {this.state.imedicos.map((item, i) => {
                      return (
                        <option
                          className={item.variable3 === 1 ? "dispo1" : ""}
                          key={i}
                          value={item.variable1}
                        >
                          {item.variable2}
                        </option>
                      );
                    })}
                  </select>
                </div>
                {this.state.especialista.length > 0 && (
                  <div className="xinventa col-3">
                    <select
                      id="inventario"
                      name="inventario"
                      value={this.state.inventario}
                      onChange={this.onChange.bind(this)}
                    >
                      <option>-Seleccione Item-</option>
                      {this.state.iinventario.map((item, i) => {
                        return (
                          <option key={i} value={item.variable1}>
                            {item.variable2}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                )}
                {this.state.inventario.length > 0 && (
                  <div className="cont-cedula col-1">
                    <label className="opcion">Monto.</label>
                    <input
                      className="form-control"
                      type="text"
                      name="monto"
                      id="monto"
                      autoComplete="off"
                      value={this.state.monto}
                      onChange={this.onChange.bind(this)}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="cont-datos-espera col-12">
              <div className="row">
                {this.state.monto.length > 0 && (
                  <div className="col-3">
                    <select
                      id="especialista2"
                      name="especialista2"
                      value={this.state.especialista2}
                      onChange={this.onChange.bind(this)}
                    >
                      <option>-Asociar Especialista-</option>
                      {this.state.imedicos.map((item, i) => {
                        return (
                          <option
                            className={item.variable3 === 1 ? "dispo1" : ""}
                            key={i}
                            value={item.variable1}
                          >
                            {item.variable2}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                )}

                {this.state.especialista2.length > 0 && (
                  <div className="cont-cedula col-1">
                    <label className="opcion">Monto.</label>
                    <input
                      className="form-control"
                      type="text"
                      name="monto22"
                      id="monto22"
                      autoComplete="off"
                      value={this.state.monto22}
                      onChange={this.onChange.bind(this)}
                    />
                  </div>
                )}
                <div className="contenedorcedula1hh col-8 row">
                  <button
                    className={this.state.modificarOn ? "botonOf" : "boton"}
                    onClick={
                      this.state.modificarOn ? "" : this.guardar.bind(this)
                    }
                  >
                    Guardar
                  </button>
                  {/* <button
                    className={this.state.modificarOn ? "boton" : "botonOf"}
                    onClick={
                      this.state.modificarOn ? this.modificar.bind(this) : ""
                    }
                  >
                    Modificar
                  </button>
                  <button
                    className="boton"
                    onClick={this.reemplazar.bind(this)}
                  >
                    Reemplazar Especialista
                  </button> */}
                  <button className="boton" onClick={this.limpiar.bind(this)}>
                    Limpiar
                  </button>
                  <Link to="/">
                    <button className="boton">Salir</button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="cont-principal-tablas col-12">
          <div className="row">
            <div className="cont-general-citas col-12">
              <span className="cont-span-cita">
                Costo de Estudios por Item Facturado
              </span>
              <div className="listadocasos">
                <table className="tablaespera1">
                  <thead>
                    <tr>
                      <th className="tituevo1">Especialista</th>
                      <th className="tituevo1">Especialidad</th>
                      <th className="tituevo1">Item Afectado</th>
                      <th className="tituevo1">Monto</th>
                      <th className="tituevo1">Asociado</th>
                      <th className="tituevo1">Monto</th>
                      {/* <th className="tituevo1">Horario</th> */}
                      <th className="tituevo1">
                        {/* <span className="cerrarme5"></span> */}
                        <span className="cerrarme3"></span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="cuerpoespera1">
                    {this.state.ifechaespera1.map((item, i) => {
                      //console.log("paso "+i);

                      return (
                        <tr
                          className={i % 2 === 0 ? "odd" : ""}
                          key={item.variable1}
                        >
                          <td
                            width="150"
                            className="itemtabla1"
                            key={item.variable1}
                          >
                            {item.variable2}
                          </td>
                          <td width="250" className="itemtabla1">
                            {item.variable3}
                          </td>
                          <td width="250" className="itemtabla1">
                            {item.variable4}
                          </td>
                          <td width="100" className="itemtabla3">
                            {item.variable5}
                          </td>
                          <td width="100" className="itemtabla1">
                            {item.variable6}
                          </td>
                          <td width="100" className="itemtabla3">
                            {item.variable7}
                          </td>
                          <td width="20">
                            {/* <span
                              className="cerrarme5"
                              onClick={this.consultar2.bind(
                                this,
                                item.variable2,
                                item.variable1
                              )}
                            ></span> */}
                            <span
                              className="cerrarme2"
                              onClick={this.eliminar.bind(this, item.variable1)}
                            ></span>{" "}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    token: state.token,
  };
};
export default connect(mapStateToProps)(MontosAction);
